package com.sweetlime.dungeonamigo.cache

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SrdDatabaseQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAllSpells(mapper: (
    slug: String,
    name: String,
    level: String?,
    school: String?,
    casting_time: String?,
    range: String?,
    duration: String?,
    components: String?,
    material: String?,
    description: String?,
    higher_level: String?,
    classes: String?,
    ritual: String?,
  ) -> T): Query<T> = Query(865_647_911, arrayOf("spells"), driver, "SrdDatabase.sq",
      "selectAllSpells",
      "SELECT spells.slug, spells.name, spells.level, spells.school, spells.casting_time, spells.range, spells.duration, spells.components, spells.material, spells.description, spells.higher_level, spells.classes, spells.ritual FROM spells ORDER BY name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12)
    )
  }

  public fun selectAllSpells(): Query<Spells> = selectAllSpells { slug, name, level, school,
      casting_time, range, duration, components, material, description, higher_level, classes,
      ritual ->
    Spells(
      slug,
      name,
      level,
      school,
      casting_time,
      range,
      duration,
      components,
      material,
      description,
      higher_level,
      classes,
      ritual
    )
  }

  public fun <T : Any> selectSpellBySlug(slug: String, mapper: (
    slug: String,
    name: String,
    level: String?,
    school: String?,
    casting_time: String?,
    range: String?,
    duration: String?,
    components: String?,
    material: String?,
    description: String?,
    higher_level: String?,
    classes: String?,
    ritual: String?,
  ) -> T): Query<T> = SelectSpellBySlugQuery(slug) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12)
    )
  }

  public fun selectSpellBySlug(slug: String): Query<Spells> = selectSpellBySlug(slug) { slug_, name,
      level, school, casting_time, range, duration, components, material, description, higher_level,
      classes, ritual ->
    Spells(
      slug_,
      name,
      level,
      school,
      casting_time,
      range,
      duration,
      components,
      material,
      description,
      higher_level,
      classes,
      ritual
    )
  }

  public fun <T : Any> searchSpellsByName(name: String, mapper: (
    slug: String,
    name: String,
    level: String?,
    school: String?,
    casting_time: String?,
    range: String?,
    duration: String?,
    components: String?,
    material: String?,
    description: String?,
    higher_level: String?,
    classes: String?,
    ritual: String?,
  ) -> T): Query<T> = SearchSpellsByNameQuery(name) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12)
    )
  }

  public fun searchSpellsByName(name: String): Query<Spells> = searchSpellsByName(name) { slug,
      name_, level, school, casting_time, range, duration, components, material, description,
      higher_level, classes, ritual ->
    Spells(
      slug,
      name_,
      level,
      school,
      casting_time,
      range,
      duration,
      components,
      material,
      description,
      higher_level,
      classes,
      ritual
    )
  }

  public fun <T : Any> selectAllMonsters(mapper: (
    slug: String,
    name: String,
    size: String?,
    type: String?,
    alignment: String?,
    armor_class: Long?,
    hit_points: Long?,
    hit_dice: String?,
    speed: String?,
    challenge_rating: String?,
    description: String?,
    actions: String?,
  ) -> T): Query<T> = Query(468_878_773, arrayOf("monsters"), driver, "SrdDatabase.sq",
      "selectAllMonsters",
      "SELECT monsters.slug, monsters.name, monsters.size, monsters.type, monsters.alignment, monsters.armor_class, monsters.hit_points, monsters.hit_dice, monsters.speed, monsters.challenge_rating, monsters.description, monsters.actions FROM monsters ORDER BY name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5),
      cursor.getLong(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun selectAllMonsters(): Query<Monsters> = selectAllMonsters { slug, name, size, type,
      alignment, armor_class, hit_points, hit_dice, speed, challenge_rating, description, actions ->
    Monsters(
      slug,
      name,
      size,
      type,
      alignment,
      armor_class,
      hit_points,
      hit_dice,
      speed,
      challenge_rating,
      description,
      actions
    )
  }

  public fun <T : Any> selectMonsterBySlug(slug: String, mapper: (
    slug: String,
    name: String,
    size: String?,
    type: String?,
    alignment: String?,
    armor_class: Long?,
    hit_points: Long?,
    hit_dice: String?,
    speed: String?,
    challenge_rating: String?,
    description: String?,
    actions: String?,
  ) -> T): Query<T> = SelectMonsterBySlugQuery(slug) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5),
      cursor.getLong(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun selectMonsterBySlug(slug: String): Query<Monsters> = selectMonsterBySlug(slug) { slug_,
      name, size, type, alignment, armor_class, hit_points, hit_dice, speed, challenge_rating,
      description, actions ->
    Monsters(
      slug_,
      name,
      size,
      type,
      alignment,
      armor_class,
      hit_points,
      hit_dice,
      speed,
      challenge_rating,
      description,
      actions
    )
  }

  public fun <T : Any> searchMonstersByName(name: String, mapper: (
    slug: String,
    name: String,
    size: String?,
    type: String?,
    alignment: String?,
    armor_class: Long?,
    hit_points: Long?,
    hit_dice: String?,
    speed: String?,
    challenge_rating: String?,
    description: String?,
    actions: String?,
  ) -> T): Query<T> = SearchMonstersByNameQuery(name) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5),
      cursor.getLong(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun searchMonstersByName(name: String): Query<Monsters> = searchMonstersByName(name) {
      slug, name_, size, type, alignment, armor_class, hit_points, hit_dice, speed,
      challenge_rating, description, actions ->
    Monsters(
      slug,
      name_,
      size,
      type,
      alignment,
      armor_class,
      hit_points,
      hit_dice,
      speed,
      challenge_rating,
      description,
      actions
    )
  }

  public fun <T : Any> selectAllItems(mapper: (
    slug: String,
    name: String,
    type: String?,
    rarity: String?,
    requires_attunement: String?,
    description: String?,
    cost: String?,
    weight: String?,
  ) -> T): Query<T> = Query(1_681_376_100, arrayOf("items"), driver, "SrdDatabase.sq",
      "selectAllItems",
      "SELECT items.slug, items.name, items.type, items.rarity, items.requires_attunement, items.description, items.cost, items.weight FROM items ORDER BY name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7)
    )
  }

  public fun selectAllItems(): Query<Items> = selectAllItems { slug, name, type, rarity,
      requires_attunement, description, cost, weight ->
    Items(
      slug,
      name,
      type,
      rarity,
      requires_attunement,
      description,
      cost,
      weight
    )
  }

  public fun <T : Any> selectItemBySlug(slug: String, mapper: (
    slug: String,
    name: String,
    type: String?,
    rarity: String?,
    requires_attunement: String?,
    description: String?,
    cost: String?,
    weight: String?,
  ) -> T): Query<T> = SelectItemBySlugQuery(slug) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7)
    )
  }

  public fun selectItemBySlug(slug: String): Query<Items> = selectItemBySlug(slug) { slug_, name,
      type, rarity, requires_attunement, description, cost, weight ->
    Items(
      slug_,
      name,
      type,
      rarity,
      requires_attunement,
      description,
      cost,
      weight
    )
  }

  public fun <T : Any> searchItemsByName(name: String, mapper: (
    slug: String,
    name: String,
    type: String?,
    rarity: String?,
    requires_attunement: String?,
    description: String?,
    cost: String?,
    weight: String?,
  ) -> T): Query<T> = SearchItemsByNameQuery(name) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7)
    )
  }

  public fun searchItemsByName(name: String): Query<Items> = searchItemsByName(name) { slug, name_,
      type, rarity, requires_attunement, description, cost, weight ->
    Items(
      slug,
      name_,
      type,
      rarity,
      requires_attunement,
      description,
      cost,
      weight
    )
  }

  public fun isCategorySynced(category: String): Query<Long> = IsCategorySyncedQuery(category) {
      cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectSyncMeta(category: String, mapper: (
    category: String,
    synced_at: Long,
    total_count: Long,
  ) -> T): Query<T> = SelectSyncMetaQuery(category) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!
    )
  }

  public fun selectSyncMeta(category: String): Query<Sync_meta> = selectSyncMeta(category) {
      category_, synced_at, total_count ->
    Sync_meta(
      category_,
      synced_at,
      total_count
    )
  }

  public fun insertOrReplaceSpell(
    slug: String,
    name: String,
    level: String?,
    school: String?,
    casting_time: String?,
    range: String?,
    duration: String?,
    components: String?,
    material: String?,
    description: String?,
    higher_level: String?,
    classes: String?,
    ritual: String?,
  ) {
    driver.execute(558_879_833, """
        |INSERT OR REPLACE INTO spells (slug, name, level, school, casting_time, range, duration, components, material, description, higher_level, classes, ritual)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 13) {
          bindString(0, slug)
          bindString(1, name)
          bindString(2, level)
          bindString(3, school)
          bindString(4, casting_time)
          bindString(5, range)
          bindString(6, duration)
          bindString(7, components)
          bindString(8, material)
          bindString(9, description)
          bindString(10, higher_level)
          bindString(11, classes)
          bindString(12, ritual)
        }
    notifyQueries(558_879_833) { emit ->
      emit("spells")
    }
  }

  public fun insertOrReplaceMonster(
    slug: String,
    name: String,
    size: String?,
    type: String?,
    alignment: String?,
    armor_class: Long?,
    hit_points: Long?,
    hit_dice: String?,
    speed: String?,
    challenge_rating: String?,
    description: String?,
    actions: String?,
  ) {
    driver.execute(-837_545_269, """
        |INSERT OR REPLACE INTO monsters (slug, name, size, type, alignment, armor_class, hit_points, hit_dice, speed, challenge_rating, description, actions)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          bindString(0, slug)
          bindString(1, name)
          bindString(2, size)
          bindString(3, type)
          bindString(4, alignment)
          bindLong(5, armor_class)
          bindLong(6, hit_points)
          bindString(7, hit_dice)
          bindString(8, speed)
          bindString(9, challenge_rating)
          bindString(10, description)
          bindString(11, actions)
        }
    notifyQueries(-837_545_269) { emit ->
      emit("monsters")
    }
  }

  public fun insertOrReplaceItem(
    slug: String,
    name: String,
    type: String?,
    rarity: String?,
    requires_attunement: String?,
    description: String?,
    cost: String?,
    weight: String?,
  ) {
    driver.execute(849_018_306, """
        |INSERT OR REPLACE INTO items (slug, name, type, rarity, requires_attunement, description, cost, weight)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, slug)
          bindString(1, name)
          bindString(2, type)
          bindString(3, rarity)
          bindString(4, requires_attunement)
          bindString(5, description)
          bindString(6, cost)
          bindString(7, weight)
        }
    notifyQueries(849_018_306) { emit ->
      emit("items")
    }
  }

  public fun upsertSyncMeta(
    category: String,
    synced_at: Long,
    total_count: Long,
  ) {
    driver.execute(-267_761_352, """
        |INSERT OR REPLACE INTO sync_meta (category, synced_at, total_count)
        |VALUES (?, ?, ?)
        """.trimMargin(), 3) {
          bindString(0, category)
          bindLong(1, synced_at)
          bindLong(2, total_count)
        }
    notifyQueries(-267_761_352) { emit ->
      emit("sync_meta")
    }
  }

  private inner class SelectSpellBySlugQuery<out T : Any>(
    public val slug: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spells", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spells", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(34_601_989,
        """SELECT spells.slug, spells.name, spells.level, spells.school, spells.casting_time, spells.range, spells.duration, spells.components, spells.material, spells.description, spells.higher_level, spells.classes, spells.ritual FROM spells WHERE slug = ?""",
        mapper, 1) {
      bindString(0, slug)
    }

    override fun toString(): String = "SrdDatabase.sq:selectSpellBySlug"
  }

  private inner class SearchSpellsByNameQuery<out T : Any>(
    public val name: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spells", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spells", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_259_638_626,
        """SELECT spells.slug, spells.name, spells.level, spells.school, spells.casting_time, spells.range, spells.duration, spells.components, spells.material, spells.description, spells.higher_level, spells.classes, spells.ritual FROM spells WHERE name LIKE ? ORDER BY name""",
        mapper, 1) {
      bindString(0, name)
    }

    override fun toString(): String = "SrdDatabase.sq:searchSpellsByName"
  }

  private inner class SelectMonsterBySlugQuery<out T : Any>(
    public val slug: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("monsters", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("monsters", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_351_621_239,
        """SELECT monsters.slug, monsters.name, monsters.size, monsters.type, monsters.alignment, monsters.armor_class, monsters.hit_points, monsters.hit_dice, monsters.speed, monsters.challenge_rating, monsters.description, monsters.actions FROM monsters WHERE slug = ?""",
        mapper, 1) {
      bindString(0, slug)
    }

    override fun toString(): String = "SrdDatabase.sq:selectMonsterBySlug"
  }

  private inner class SearchMonstersByNameQuery<out T : Any>(
    public val name: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("monsters", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("monsters", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-171_563_668,
        """SELECT monsters.slug, monsters.name, monsters.size, monsters.type, monsters.alignment, monsters.armor_class, monsters.hit_points, monsters.hit_dice, monsters.speed, monsters.challenge_rating, monsters.description, monsters.actions FROM monsters WHERE name LIKE ? ORDER BY name""",
        mapper, 1) {
      bindString(0, name)
    }

    override fun toString(): String = "SrdDatabase.sq:searchMonstersByName"
  }

  private inner class SelectItemBySlugQuery<out T : Any>(
    public val slug: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("items", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("items", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_095_286_758,
        """SELECT items.slug, items.name, items.type, items.rarity, items.requires_attunement, items.description, items.cost, items.weight FROM items WHERE slug = ?""",
        mapper, 1) {
      bindString(0, slug)
    }

    override fun toString(): String = "SrdDatabase.sq:selectItemBySlug"
  }

  private inner class SearchItemsByNameQuery<out T : Any>(
    public val name: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("items", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("items", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(468_913_233,
        """SELECT items.slug, items.name, items.type, items.rarity, items.requires_attunement, items.description, items.cost, items.weight FROM items WHERE name LIKE ? ORDER BY name""",
        mapper, 1) {
      bindString(0, name)
    }

    override fun toString(): String = "SrdDatabase.sq:searchItemsByName"
  }

  private inner class IsCategorySyncedQuery<out T : Any>(
    public val category: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("sync_meta", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("sync_meta", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_432_759_371, """SELECT COUNT(*) FROM sync_meta WHERE category = ?""",
        mapper, 1) {
      bindString(0, category)
    }

    override fun toString(): String = "SrdDatabase.sq:isCategorySynced"
  }

  private inner class SelectSyncMetaQuery<out T : Any>(
    public val category: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("sync_meta", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("sync_meta", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_719_945_221,
        """SELECT sync_meta.category, sync_meta.synced_at, sync_meta.total_count FROM sync_meta WHERE category = ?""",
        mapper, 1) {
      bindString(0, category)
    }

    override fun toString(): String = "SrdDatabase.sq:selectSyncMeta"
  }
}
